import React from 'react'
import { Route, Switch } from 'react-router-dom'
import cn from 'classnames'

import ProfileLoader from 'app/domains/common/Loaders/ProfileLoader'
import ProfileMenu from './Menu'
import ProfileHeader from './Header'
import ProfileGeneral from './General'
import Notifications from './Notifications'
import OutOfOffice from './OutOfOffice'
import ActiveProTracks from './ActiveProTracks'
import Footer from './Footer'
import FormWrapper from './FormWrapper'
import * as STAGES from 'app/constants/stages'

import './profile-input.scss' // TODO: move to appropriate input components
import './styles.scss'

const UserProfile = ({ stage, pending, isMobile, match, handleSubmit, pristine, submitting }) => {
  return (
    <div className={cn('user-profile', { 'user-profile--selection': stage === STAGES.SELECTION })}>
      <ProfileHeader />
      {pending ? (
        <ProfileLoader />
      ) : (
        <div className="profile-content-wrapper">
          <Route path="/profile" component={ProfileMenu} exact={isMobile} />
          <FormWrapper
            isMobile={isMobile}
            handleSubmit={handleSubmit}
            footer={<Footer pristine={pristine} submitting={submitting} />}
          >
            <Switch>
              <Route path={`${match.path}/general`} component={ProfileGeneral} />
              <Route path={`${match.path}/notifications`} component={Notifications} />
              <Route path={`${match.path}/out-of-office`} component={OutOfOffice} />
              <Route path={`${match.path}/active-protracks`} component={ActiveProTracks} />
            </Switch>
          </FormWrapper>
        </div>
      )}
    </div>
  )
}

export default UserProfile
